if (!customElements.get('gf-delivery-estimate')) {
  customElements.define('gf-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = document.getElementById(this.dataset.productForm);
      if (!this.form) return;
      this.excluded = new Set((this.dataset.excludedVariants || '').split(',').filter(Boolean));
      this.furniture = this.querySelector('[data-delivery-furniture]');
      this.stock = this.querySelector('[data-delivery-stock]');
      this.customDetails = this.querySelector('[data-delivery-custom-details]');
      this.stockDetails = this.querySelector('[data-delivery-stock-details]');
      this.property = this.querySelector('[data-delivery-property]');
      const options = { signal: this.controller.signal };
      this.form.addEventListener('change', () => this.sync(), options);
      this.form.addEventListener('submit', () => this.sync(), { ...options, capture: true });
      this.form.addEventListener('formdata', event => {
        if (!this.property) return;
        if (this.sync()) event.formData.set(this.property.name, this.property.value);
        else event.formData.delete(this.property.name);
      }, options);
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    sync() {
      const variant = this.form?.querySelector('[name="id"]');
      const valid = !!variant?.value;
      const custom = valid && this.dataset.upholsteredProduct === 'true' && !this.excluded.has(String(variant.value));
      if (this.furniture) this.furniture.hidden = !custom;
      if (this.stock) this.stock.hidden = custom;
      if (this.customDetails) this.customDetails.hidden = !custom;
      if (this.stockDetails) this.stockDetails.hidden = custom;
      if (this.property) {
        this.property.disabled = !valid;
        this.property.value = custom ? this.dataset.customEstimate : this.dataset.stockEstimate;
      }
      return valid;
    }
  });
}
